export enum LaborPartnerKindEnum {
  SOLAR = "solar",
  ROOFING = "roofing",
}

export enum PreferredPartnerStatusEnum {
  REQUESTED = "requested",
  ASSIGNED = "assigned",
  NOT_FOUND = "not_found",
}

export enum PartnerPathEnum {
  INSTALL = "install_partners",
  ROOFING = "roofing_partners",
}
